"use client";
import productsData from "./SupportTeamData";
import { Col } from "react-bootstrap";

export default function Products() {
  const handleBookMeeting = (url) => {
    if (window.Calendly) {
      Calendly.initPopupWidget({ url });
    } else {
      console.warn("Calendly script not loaded");
    }
  };

  return (
    <>
      {productsData.map((product, index) => (
        <Col xs={12} md={2} key={product.id || index}>
          <div className="wpr-member-media">
            <img src={product.img} alt={product.Sname} className="img-fluid" />
          </div>
          <div className="wpr-member-content">
            <h3 className="wpr-member-name">{product.Sname}</h3>
            <div className="wpr-member-job">{product.Sdesignation}</div>
            {/* <div className="wpr-member-divider"></div> */}

            {/* Show Calendly link only if available */}
            {product.calendly && (
              <button
                onClick={() => handleBookMeeting(product.calendly)}
                className="btn btn-connect mt-2"
              >
                Schedule time with me
              </button>
            )}
            <div className="wpr-member-divider"></div>
          </div>
        </Col>
      ))}
    
    </>
  );
}
